<cng-display></cng-display>
<cng-toaster class="cng-dark-contrast"></cng-toaster>
<router-outlet></router-outlet>
<div id="external-apps-container" #appExternalContainer></div>
